module.exports = __webpack_public_path__ + "img/cloth_g3_hat-04.c6a8d0c8.svg";